import { _ as _sfc_main, a as _sfc_main$1 } from "./BAccordionItem.vue_vue_type_script_setup_true_lang-AgwEJ73c.mjs";
import { B as BAlert } from "./BAlert-t4xRB7pC.mjs";
import { _ as _sfc_main$2, a as _sfc_main$3 } from "./BAvatarGroup.vue_vue_type_script_setup_true_lang-5PBAGGTP.mjs";
import { _ as _sfc_main$4 } from "./BBadge.vue_vue_type_script_setup_true_lang-BQbv5hMw.mjs";
import { _ as _sfc_main$5, a as _sfc_main$6 } from "./BBreadcrumb.vue_vue_type_script_setup_true_lang-CRIZoZeV.mjs";
import { _ as _sfc_main$7 } from "./BButton.vue_vue_type_script_setup_true_lang-CywtlN38.mjs";
import { _ as _sfc_main$8, a as _sfc_main$9 } from "./BButtonToolbar.vue_vue_type_script_setup_true_lang-qymZ6O0g.mjs";
import { _ as _sfc_main$l } from "./BCloseButton.vue_vue_type_script_setup_true_lang-DjJD_nYp.mjs";
import { _ as _sfc_main$a, a as _sfc_main$b, b as _sfc_main$c, c as _sfc_main$e, d as _sfc_main$f, e as _sfc_main$g, f as _sfc_main$i } from "./BCard.vue_vue_type_script_setup_true_lang-DXWrClcW.mjs";
import { _ as _sfc_main$d, a as _sfc_main$h } from "./BCardText.vue_vue_type_script_setup_true_lang-VEvK_j1X.mjs";
import { _ as _sfc_main$j, a as _sfc_main$k } from "./BCarouselSlide.vue_vue_type_script_setup_true_lang-C38VxQgW.mjs";
import { _ as _sfc_main$n } from "./BCollapse.vue_vue_type_script_setup_true_lang-vGXlzSIV.mjs";
import { _ as _sfc_main$m } from "./BCol.vue_vue_type_script_setup_true_lang-suozSq48.mjs";
import { _ as _sfc_main$o } from "./BContainer.vue_vue_type_script_setup_true_lang-amTLVjJN.mjs";
import { _ as _sfc_main$1h } from "./BRow.vue_vue_type_script_setup_true_lang-0hLWSzY1.mjs";
import { _ as _sfc_main$p } from "./BDropdown.vue_vue_type_script_setup_true_lang-BPR8NXKb.mjs";
import { _ as _sfc_main$q, a as _sfc_main$r, b as _sfc_main$s, c as _sfc_main$t, d as _sfc_main$u, e as _sfc_main$v, f as _sfc_main$w } from "./BDropdownText.vue_vue_type_script_setup_true_lang-BDwerYPM.mjs";
import { _ as _sfc_main$x } from "./BForm.vue_vue_type_script_setup_true_lang-47Vj3UA2.mjs";
import { _ as _sfc_main$A, a as _sfc_main$C } from "./BFormFloatingLabel.vue_vue_type_script_setup_true_lang-CIeh0lsL.mjs";
import { _ as _sfc_main$F, a as _sfc_main$I, b as _sfc_main$P, c as _sfc_main$R } from "./BFormValidFeedback.vue_vue_type_script_setup_true_lang-xcsogHHN.mjs";
import { _ as _sfc_main$y, a as _sfc_main$z } from "./BFormCheckboxGroup.vue_vue_type_script_setup_true_lang-qmX0MPIN.mjs";
import { _ as _sfc_main$B } from "./BFormFile.vue_vue_type_script_setup_true_lang-C7MTQF1-.mjs";
import { _ as _sfc_main$D } from "./BFormGroup.vue_vue_type_script_setup_true_lang-KPW5o1XV.mjs";
import { _ as _sfc_main$E } from "./BFormInput.vue_vue_type_script_setup_true_lang-C8Wa81cB.mjs";
import { _ as _sfc_main$G, a as _sfc_main$H } from "./BFormRadioGroup.vue_vue_type_script_setup_true_lang-u-EudL9M.mjs";
import { _ as _sfc_main$J, a as _sfc_main$L } from "./BFormSelect.vue_vue_type_script_setup_true_lang-B2LqCugy.mjs";
import { _ as _sfc_main$K } from "./useFormSelect-DAr__bvr.mjs";
import { _ as _sfc_main$M } from "./BFormSpinbutton.vue_vue_type_script_setup_true_lang-D2L1cFug.mjs";
import { a as _sfc_main$N, _ as _sfc_main$O } from "./BFormTags.vue_vue_type_script_setup_true_lang-BTvSD2lh.mjs";
import { _ as _sfc_main$Q } from "./BFormTextarea.vue_vue_type_script_setup_true_lang-3ZSab3T0.mjs";
import { _ as _sfc_main$S } from "./BImg.vue_vue_type_script_setup_true_lang-BeMDI0oP.mjs";
import { _ as _sfc_main$T, a as _sfc_main$U } from "./BInputGroupText.vue_vue_type_script_setup_true_lang-B11o7IpN.mjs";
import { _ as _sfc_main$V } from "./BLink.vue_vue_type_script_setup_true_lang-DTMTuVcR.mjs";
import { _ as _sfc_main$W, a as _sfc_main$X } from "./BListGroupItem.vue_vue_type_script_setup_true_lang-BNWW9tJp.mjs";
import { _ as _sfc_main$Y, a as _sfc_main$Z } from "./BModalOrchestrator.vue_vue_type_script_setup_true_lang-DtHGvqlM.mjs";
import { _ as _sfc_main$_, a as _sfc_main$$, b as _sfc_main$10, c as _sfc_main$11, d as _sfc_main$12 } from "./BNavText.vue_vue_type_script_setup_true_lang-B4Z1FrCG.mjs";
import { _ as _sfc_main$13, a as _sfc_main$14, b as _sfc_main$15, c as _sfc_main$16 } from "./BNavbarToggle.vue_vue_type_script_setup_true_lang-ByQQnRp5.mjs";
import { B as BOffcanvas } from "./BOffcanvas-DH1MW9Or.mjs";
import { _ as _sfc_main$17 } from "./BOverlay.vue_vue_type_script_setup_true_lang-BNagP-aH.mjs";
import { _ as _sfc_main$18 } from "./BPagination.vue_vue_type_script_setup_true_lang-l5GT5VPN.mjs";
import { _ as _sfc_main$19, a as _sfc_main$1a, b as _sfc_main$1b, c as _sfc_main$1c, d as _sfc_main$1d } from "./BPlaceholderWrapper.vue_vue_type_script_setup_true_lang-B13c8VVG.mjs";
import { B as BPopover } from "./floatingUi-D2mifeW0.mjs";
import { _ as _sfc_main$1e } from "./BPopoverOrchestrator.vue_vue_type_script_setup_true_lang-BADk7-n8.mjs";
import { _ as _sfc_main$1f, a as _sfc_main$1g } from "./BProgress.vue_vue_type_script_setup_true_lang-Bft5GlO-.mjs";
import { _ as _sfc_main$1i } from "./BSpinner.vue_vue_type_script_setup_true_lang-BtYfD0A-.mjs";
import { _ as _sfc_main$1k, a as _sfc_main$1l, b as _sfc_main$1o, c as _sfc_main$1p, d as _sfc_main$1q, e as _sfc_main$1r, f as _sfc_main$1s, g as _sfc_main$1v } from "./BTable.vue_vue_type_script_setup_true_lang-CYs9k7_p.mjs";
import { _ as _sfc_main$1m } from "./BTableSimple.vue_vue_type_script_setup_true_lang-N6nsvv6z.mjs";
import { _ as _sfc_main$1j, a as _sfc_main$1n } from "./BTabs.vue_vue_type_script_setup_true_lang-BHo2I5wE.mjs";
import { B as BToast, _ as _sfc_main$1t } from "./BToastOrchestrator.vue_vue_type_style_index_0_lang-qQXgn_O_.mjs";
import { _ as _sfc_main$1u } from "./BTooltip.vue_vue_type_script_setup_true_lang-27IZ7bOv.mjs";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAccordion: _sfc_main,
  BAccordionItem: _sfc_main$1,
  BAlert,
  BAvatar: _sfc_main$2,
  BAvatarGroup: _sfc_main$3,
  BBadge: _sfc_main$4,
  BBreadcrumb: _sfc_main$5,
  BBreadcrumbItem: _sfc_main$6,
  BButton: _sfc_main$7,
  BButtonGroup: _sfc_main$8,
  BButtonToolbar: _sfc_main$9,
  BCard: _sfc_main$a,
  BCardBody: _sfc_main$b,
  BCardFooter: _sfc_main$c,
  BCardGroup: _sfc_main$d,
  BCardHeader: _sfc_main$e,
  BCardImg: _sfc_main$f,
  BCardSubtitle: _sfc_main$g,
  BCardText: _sfc_main$h,
  BCardTitle: _sfc_main$i,
  BCarousel: _sfc_main$j,
  BCarouselSlide: _sfc_main$k,
  BCloseButton: _sfc_main$l,
  BCol: _sfc_main$m,
  BCollapse: _sfc_main$n,
  BContainer: _sfc_main$o,
  BDropdown: _sfc_main$p,
  BDropdownDivider: _sfc_main$q,
  BDropdownForm: _sfc_main$r,
  BDropdownGroup: _sfc_main$s,
  BDropdownHeader: _sfc_main$t,
  BDropdownItem: _sfc_main$u,
  BDropdownItemButton: _sfc_main$v,
  BDropdownText: _sfc_main$w,
  BForm: _sfc_main$x,
  BFormCheckbox: _sfc_main$y,
  BFormCheckboxGroup: _sfc_main$z,
  BFormDatalist: _sfc_main$A,
  BFormFile: _sfc_main$B,
  BFormFloatingLabel: _sfc_main$C,
  BFormGroup: _sfc_main$D,
  BFormInput: _sfc_main$E,
  BFormInvalidFeedback: _sfc_main$F,
  BFormRadio: _sfc_main$G,
  BFormRadioGroup: _sfc_main$H,
  BFormRow: _sfc_main$I,
  BFormSelect: _sfc_main$J,
  BFormSelectOption: _sfc_main$K,
  BFormSelectOptionGroup: _sfc_main$L,
  BFormSpinbutton: _sfc_main$M,
  BFormTag: _sfc_main$N,
  BFormTags: _sfc_main$O,
  BFormText: _sfc_main$P,
  BFormTextarea: _sfc_main$Q,
  BFormValidFeedback: _sfc_main$R,
  BImg: _sfc_main$S,
  BInput: _sfc_main$E,
  BInputGroup: _sfc_main$T,
  BInputGroupText: _sfc_main$U,
  BLink: _sfc_main$V,
  BListGroup: _sfc_main$W,
  BListGroupItem: _sfc_main$X,
  BModal: _sfc_main$Y,
  BModalOrchestrator: _sfc_main$Z,
  BNav: _sfc_main$_,
  BNavForm: _sfc_main$$,
  BNavItem: _sfc_main$10,
  BNavItemDropdown: _sfc_main$11,
  BNavText: _sfc_main$12,
  BNavbar: _sfc_main$13,
  BNavbarBrand: _sfc_main$14,
  BNavbarNav: _sfc_main$15,
  BNavbarToggle: _sfc_main$16,
  BOffcanvas,
  BOverlay: _sfc_main$17,
  BPagination: _sfc_main$18,
  BPlaceholder: _sfc_main$19,
  BPlaceholderButton: _sfc_main$1a,
  BPlaceholderCard: _sfc_main$1b,
  BPlaceholderTable: _sfc_main$1c,
  BPlaceholderWrapper: _sfc_main$1d,
  BPopover,
  BPopoverOrchestrator: _sfc_main$1e,
  BProgress: _sfc_main$1f,
  BProgressBar: _sfc_main$1g,
  BRow: _sfc_main$1h,
  BSpinner: _sfc_main$1i,
  BTab: _sfc_main$1j,
  BTable: _sfc_main$1k,
  BTableLite: _sfc_main$1l,
  BTableSimple: _sfc_main$1m,
  BTabs: _sfc_main$1n,
  BTbody: _sfc_main$1o,
  BTd: _sfc_main$1p,
  BTfoot: _sfc_main$1q,
  BTh: _sfc_main$1r,
  BThead: _sfc_main$1s,
  BToast,
  BToastOrchestrator: _sfc_main$1t,
  BTooltip: _sfc_main$1u,
  BTr: _sfc_main$1v
}, Symbol.toStringTag, { value: "Module" }));
export {
  index as i
};
//# sourceMappingURL=index-BQLK1nAJ.mjs.map
